module.exports = __webpack_public_path__ + "static/media/facebook-icon.ea453b5d.svg";